import { DeviceType } from '@/src/types'
import { getAppAgent, isEmpty } from '@/src/utils/helper'
import { logError } from '@/src/utils/logError'
import { VISA_ERRORS, ERROR_MESSAGES } from '@/src/constants/error'
import axios, { AxiosRequestConfig } from 'axios'

export const apiGetHelper = async ({
    URL = '',
    contentType = '',
    requestHeaders = {},
    deviceType,
    skipErrorHandling = false
}: {
    URL: string
    contentType?: string
    requestHeaders?: object
    deviceType: DeviceType
    skipErrorHandling?: boolean
}) => {
    try {
        let contentTypeText = 'application/json; charset=UTF-8, text/html'
        if (contentType) {
            contentTypeText = contentType
        }
        const appAgent = deviceType ? getAppAgent(deviceType) : 'N/A'
        let headers = {
            Accept: 'application/json',
            'Content-Type': contentTypeText,
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
            X_CT_SOURCETYPE: 'MOBILE',
            'app-agent': appAgent
        }
        if (typeof window !== 'undefined') {
            headers = { ...headers, ...window.androidData, ...window.iosData }
        }
        if (!isEmpty(requestHeaders)) {
            headers = {
                ...headers,
                ...requestHeaders
            }
        }
        const responseData = await axios.get(URL, {
            headers
        })
        return responseData
    } catch (e) {
        logError('apiGetHelper', e)
        return e
    }
}
